export var ConfigValue;
(function (ConfigValue) {
    ConfigValue["OBJECT_STORE_IAM_CREDENTIALS"] = "iam";
    ConfigValue["OBJECT_STORE_STS_CREDENTIALS"] = "sts";
})(ConfigValue || (ConfigValue = {}));
